<template>
  <div class="vehicle-tile-skeleton">
    <wb-aspect-ratio ratio="16x9">
      <wb-skeleton class="vehicle-tile-skeleton__image" />
    </wb-aspect-ratio>

    <div class="vehicle-tile-skeleton__vehicle-data">
      <wb-skeleton class="vehicle-tile-skeleton__title" />

      <wb-skeleton class="vehicle-tile-skeleton__power" />
      <wb-skeleton class="vehicle-tile-skeleton__engine" />

      <section class="vehicle-tile-skeleton__price-wrapper">
        <wb-skeleton v-for="n in 2" :key="n" class="vehicle-tile-skeleton__price" />
      </section>

      <wb-skeleton class="vehicle-tile-skeleton__highlights" />

      <wb-skeleton
        v-for="n in 3"
        :key="n"
        :class="`vehicle-tile-skeleton__emico--${n}`"
        class="vehicle-tile-skeleton__emico"
      />

      <wb-skeleton class="vehicle-tile-skeleton__cta" />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'VehicleTileSkeleton',
};
</script>

<style lang="scss" scoped>
.vehicle-tile-skeleton {
  &__vehicle-data {
    display: flex;
    flex-direction: column;
    padding: var(--wb-spacing-xs);
    background-color: var(--wb-grey-90);
  }

  &__title,
  &__power,
  &__engine {
    height: 24px;
    align-self: center;
  }

  &__title {
    margin: var(--wb-spacing-s) 0;
    width: 100%;
  }

  &__power {
    width: 30%;
    margin-bottom: var(--wb-spacing-xxs);
  }

  &__engine {
    width: 50%;
  }

  &__price-wrapper {
    display: flex;
    flex-direction: row;
    column-gap: var(--wb-spacing-xxs);
    margin-top: var(--wb-spacing-s);
    margin-bottom: var(--wb-spacing-xxs);
  }

  &__price {
    height: 76px;
    width: 100%;
  }

  &__highlights {
    width: 100%;
    height: 76px;
    margin-bottom: var(--wb-spacing-s);
  }

  &__emico {
    height: 16px;
    margin-bottom: var(--wb-spacing-xxs);

    &--1 {
      width: 75%;
    }

    &--2 {
      width: 50%;
    }

    &--3 {
      width: 25%;
    }
  }

  &__cta {
    margin-top: var(--wb-spacing-s);
    height: 56px;
    width: 100%;
  }
}
</style>
